'use client';
import Box from '@mui/material/Box';
import { classNames } from '@repo/ui/src/utils/classNames';
import CheckIcon from '@repo/ui/src/components/Icons/CheckIcon';
import { useTheme } from '@mui/material/styles';
import BaseAccordion from '../../components/BaseAccordion';
import Button from '@repo/ui/src/components/Button';

const FilterAccordion = ({ currentFilters, setFilters, filter }) => {
  const { options, filterType, title } = filter || {};
  const theme = useTheme();
  return (
    <BaseAccordion titleVariant="body1" title={title} className="[&_before]:!tw-bg-white">
      {options?.map((series) => {
        const isActive =
          currentFilters &&
          currentFilters[filterType] &&
          currentFilters[filterType].includes(series.filter);
        return (
          <Box textAlign="left" mb={2} key={series.title}>
            <Button
              className={classNames(isActive && 'tw-font-bold tw-py-0')}
              onClick={(e) => {
                e.preventDefault();
                setFilters({ filterName: series.filter, filterType });
              }}
              variant="bare"
              size="small"
            >
              <CheckIcon
                color={isActive ? theme.palette.neutral[800] : 'white'}
                aria-hidden
                className="tw-mr-1"
              />
              {series.title}
            </Button>
          </Box>
        );
      })}
    </BaseAccordion>
  );
};

export default FilterAccordion;
